import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const channelA = () => import("../containers/channelA"); // 渠道a 容器
const channelB = () => import("../containers/channelB"); // 渠道b 容器
const channelC = () => import("../containers/channelC"); // 渠道c 容器
const channelC1 = () => import("../containers/channelC1"); // 渠道c 容器
const channelD = () => import("../containers/channelD"); // 渠道D 容器
const registShare = () => import("../containers/registShare"); // 邀请注册容器
const bookA = () => import("../containers/bookA"); // 图书配套A 容器
const downloadPage = () => import("../containers/downloadPage"); // 激活码、兑换券容器
const daPing = () => import("../containers/daPing"); // 大屏 容器

const channelAIndex = () => import("../pages/channelA/index");
const channelBIndex = () => import("../pages/channelB/index");

const channelCLogin = () => import("../pages/channelC/login");
const channelCIndex = () => import("../pages/channelC/index");

const channelC1Input = () => import("../pages/channelC1/input");
const channelC1Index = () => import("../pages/channelC1/index");

const channelDLogin = () => import("../pages/channelD/login");
const channelDIndex = () => import("../pages/channelD/index");
const channelDDownload = () => import("../pages/channelD/download");


const bookALogin = () => import("../pages/bookA/login");
const bookAIndex = () => import("../pages/bookA/index");
const bookAVideotutorial = () => import("../pages/bookA/videotutorial");
const bookARegister = () => import("../pages/bookA/register");
const coupons = () => import("../pages/downloadPage/coupons");

const shareLogin = () => import("../pages/registShare/login");
const bshareIndex = () => import("../pages/registShare/index");

const dapingIndex = () => import("../pages/daPing/index")

const huiyuan = () => import("../pages/huiyuan/index"); // 渠道D 容器
const chemistry = () => import("../pages/huiyuan/index1"); // 化学
const mathematics = () => import("../pages/huiyuan/index2"); // 数学
const physics = () => import("../pages/huiyuan/index3"); // 物理
const biology = () => import("../pages/huiyuan/index4"); // 生物
const mind = () => import("../pages/huiyuan/index5"); // 思维
const taozhuang = () => import("../pages/huiyuan/taozhuang"); // 思维


const banner1 = () => import("../pages/banner/banner1");
const banner2 = () => import("../pages/banner/banner2");
const banner3 = () => import("../pages/banner/banner3");

const videoPlayer = () => import("../pages/videoPlayer/index"); // 视频播放器

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/channelA",
      name: "channelA",
      component: channelA,
      children: [
        {
          path: "/channelA",
          name: "channelAIndex",
          component: channelAIndex
        }
      ]
    },
    {
      path: "/channelB",
      name: "channelB",
      component: channelB,
      children: [
        {
          path: "/channelB",
          name: "channelBIndex",
          component: channelBIndex
        }
      ]
    },
    {
      path: "/channelC",
      name: "channelC",
      component: channelC,
      children: [
        {
          path: "/channelC",
          name: "channelCLogin",
          component: channelCLogin
        },
        {
          path: "/channelCIndex",
          name: "channelCIndex",
          component: channelCIndex
        }
      ]
    },
    {
        path: "/channelC1",
        name: "channelC1",
        component: channelC,
        children: [
          {
            path: "/channelC1",
            name: "channelC1Input",
            component: channelC1Input
          },
          {
            path: "/channelC1Index",
            name: "channelC1Index",
            component: channelC1Index
          }
        ]
      },
      
    {
      path: "/regist4share",
      name: "regist4share",
      component: registShare,
      children: [
        {
          path: "/regist4share",
          name: "regist4shareLogin",
          component: shareLogin
        },
        {
          path: "/regist4shareIndex",
          name: "regist4shareIndex",
          component: bshareIndex
        }
      ]
    },{
      path: "/huiyuan",
      name: "huiyuan",
      component: huiyuan,
      children: [
      ]
    },
		{
		  path: "/chemistry",
		  name: "chemistry",
		  component: chemistry,
		  children: [
		  ]
		},
		{
		  path: "/mathematics",
		  name: "mathematics",
		  component: mathematics,
		  children: [
		  ]
		},
		{
		  path: "/physics",
		  name: "physics",
		  component: physics,
		  children: [
		  ]
		},
		{
		  path: "/biology",
		  name: "biology",
		  component: biology,
		  children: [
		  ]
		},{
		  path: "/mind",
		  name: "mind",
		  component: mind,
		  children: [
		  ]
		},{
			  path: "/taozhuang",
			  name: "taozhuang",
			  component: taozhuang,
			  children: [
			  ]		
		},{
		  path: "/banner1",
		  name: "banner1",
		  component: banner1,
		  children: [
		  ]
		},{
		  path: "/banner2",
		  name: "banner2",
		  component: banner2,
		  children: [
		  ]
		},{
		  path: "/banner3",
		  name: "banner3",
		  component: banner3,
		  children: [
		  ]
		},
	{
      path: "/channelD",
      name: "channelD",
      component: channelD,
      children: [
        {
          path: "/channelD",
          name: "channelDDownload",
          component: channelDDownload
//          name: "channelDLogin",
//          component: channelDLogin
        },
        {
          path: "/channelDIndex",
          name: "channelDIndex",
          component: channelDIndex
        },
        {
            path: "/channelDDownload",
            name: "channelDDownload",
            component: channelDDownload
        }
      ]
    },
    {
      path: "/bookA",
      name: "bookA",
      component: bookA,
      children: [
        {
          path: "/bookA",
          name: "bookALogin",
          component: bookALogin
        },
        {
          path: "/bookAIndex",
          name: "bookAIndex",
          component: bookAIndex
        },
        {
          path: "/bookARegister",
          name: "bookARegister",
          component: bookARegister
        },
        {
          path: "videotutorial",
          name: "bookAVideotutorial",
          component: bookAVideotutorial
        }
      ]
    },
    {
      path: "/downloadpage",
      name: "downloadPage",
      component: downloadPage,
      children: [
        {
          path: "/downloadpage/coupons",
          name: "coupons",
          component: coupons
        }
      ]
    },
    {
      path: "/daPing",
      name: "daPing",
      component: daPing,
      children: [
        {
          path: '/daping',
          name: 'dapingIndex',
          component: dapingIndex
        }
      ]
    },
    {
      path: "/videoPlayer/:id",
      name: "videoPlayer",
      component: videoPlayer
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js